/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earlybirdinfodescription3Inputs */

const en_earlybirdinfodescription3 = /** @type {(inputs: Earlybirdinfodescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you are an early bird subscriber and upgrade or downgrade to a different plan, you will lose your price advantage.`)
};

const de_earlybirdinfodescription3 = /** @type {(inputs: Earlybirdinfodescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du ein Early-Bird-Abo hast und auf ein höheres oder niedrigeres Abo-Modell wechselst, verlierst du deinen Preisvorteil.`)
};

/**
* | output |
* | --- |
* | "If you are an early bird subscriber and upgrade or downgrade to a different plan, you will lose your price advantage." |
*
* @param {Earlybirdinfodescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earlybirdinfodescription3 = /** @type {((inputs?: Earlybirdinfodescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earlybirdinfodescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earlybirdinfodescription3(inputs)
	return de_earlybirdinfodescription3(inputs)
});
export { earlybirdinfodescription3 as "earlyBirdInfoDescription" }